import { formatFullDate, formatTime } from '@apps/web/lib/date_utils';
import { withTemplateVariableAliases } from '@apps/web/lib/template_variables';
import {
    type Organization,
    type Shift,
} from '@libraries/typescript/api_client';

type MergeAgentInstructionsArgs = {
    readonly generatedInstructions: string | null | undefined;
    readonly template: string | null | undefined;
    readonly shifts: Array<Shift>;
    readonly organization: Organization | undefined;
};

export function renderAgentInstructionsTemplate(
    template: string,
    shifts: Array<Shift>,
    organization: Organization | undefined,
): string {
    const shift = shifts[0];
    if (!shift) {
        return template;
    }

    const timezone = organization?.timezone ?? 'UTC';
    const variables = withTemplateVariableAliases({
        organization_name: organization?.name ?? '',
        shift_date: formatFullDate(shift.shift_start_time, timezone),
        shift_start_time: formatTime(shift.shift_start_time, timezone),
        shift_end_time: formatTime(shift.shift_end_time, timezone),
        client_city: shift.patient_city ?? '',
        role_required: shift.role_required?.toUpperCase() ?? '',
    });

    return template.replace(/\{(\w+)\}/g, (_, varName: string) => {
        return variables[varName] ?? '';
    });
}

export function mergeGeneratedAndTemplateAgentInstructions({
    generatedInstructions,
    template,
    shifts,
    organization,
}: MergeAgentInstructionsArgs): string {
    const trimmedGenerated = generatedInstructions?.trim() ?? '';
    if (!template) {
        return trimmedGenerated;
    }

    const renderedTemplate = renderAgentInstructionsTemplate(
        template,
        shifts,
        organization,
    ).trim();

    if (trimmedGenerated && renderedTemplate) {
        return `${trimmedGenerated}\n\n${renderedTemplate}`;
    }
    return trimmedGenerated || renderedTemplate;
}
